import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getCurrentUser: () => api.get('/auth/me'),
  createEmployee: (data) => api.post('/auth/create-employee', data),
  getEmployees: () => api.get('/users'),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
};

// Projects API
export const projectsAPI = {
  getAll: () => api.get('/projects'),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`)
};

// Backlog Tasks API
export const backlogTasksAPI = {
  getByProject: (projectId) => api.get(`/backlog-tasks/project/${projectId}`),
  getById: (id) => api.get(`/backlog-tasks/${id}`),
  create: (data) => api.post('/backlog-tasks', data),
  update: (id, data) => api.put(`/backlog-tasks/${id}`, data),
  delete: (id) => api.delete(`/backlog-tasks/${id}`)
};

// Daily Plans API
export const dailyPlansAPI = {
  getToday: () => api.get('/daily-plans/today'),
  getByDate: (date) => api.get(`/daily-plans/date/${date}`),
  getMyPlans: () => api.get('/daily-plans/my-plans'),
  addTask: (data) => api.post('/daily-plans/today/tasks', data),
  removeTask: (taskId) => api.delete(`/daily-plans/today/tasks/${taskId}`),
  checkIn: () => api.post('/daily-plans/today/checkin'),
  checkOut: () => api.post('/daily-plans/checkout'),
  updateTaskLog: (taskId, data) => api.put(`/daily-plans/today/tasks/${taskId}/log`, data),
  submitLogs: () => api.post('/daily-plans/today/submit-logs'),
  getAllPlans: () => api.get('/daily-plans/all'),
};

export default api;
